import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { SessionUploadStatus } from './types'
import { uploadStatusApi } from './api'

export const uploadStatus = createEntityAdapter<SessionUploadStatus>()

export const initialState = uploadStatus.getInitialState({})

export const uploadStatusSlice = createSlice({
  name: 'uploadStatus',
  initialState: initialState,
  reducers: {
    upsertOne: uploadStatus.upsertOne,
    upsertMany: uploadStatus.upsertMany,
    removeOne: uploadStatus.removeOne,
    removeAll: uploadStatus.removeAll
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      uploadStatusApi.endpoints.getStatusForSession.matchFulfilled,
      (state, { payload }) => {
        if (payload) {
          uploadStatus.upsertOne(state, payload)
        }
      }
    )
    builder.addMatcher(
      uploadStatusApi.endpoints.getAllStatus.matchFulfilled,
      (state, { payload }) => {
        if (payload) {
          uploadStatus.upsertMany(state, payload)
        }
      }
    )
  }
})

export const reducer = uploadStatusSlice.reducer

export const { upsertOne: upsertUploadStatus } = uploadStatusSlice.actions
